<template>
  <div class="doctor-target">
    <label>{{ title }}<input
      v-model="search"
      :placeholder="words.pickerSearch"
      maxlength="80"
      @keydown.enter.prevent="find"
    ></label><button
      type="button"
      :disabled="loading || search.trim().length < 2"
      @click="find"
    >
      {{ words.pick }}
    </button>
    <div
      v-for="id in value"
      :key="`selected-${id}`"
      class="campaign-actions"
    >
      <span><bdi dir="auto">{{ name(id) }}</bdi></span><button
        type="button"
        @click="remove(id)"
      >
        {{ words.remove }}
      </button>
    </div>
    <label
      v-for="option in options"
      :key="`option-${option.id}`"
      class="check"
    ><input
      :type="maximum === 1 ? 'radio' : 'checkbox'"
      :name="maximum === 1 ? `picker-${kind}-${title}` : null"
      :checked="value.includes(option.id)"
      :disabled="maximum !== 1 && !value.includes(option.id) && value.length >= maximum"
      @change="toggle(option)"
    ><bdi dir="auto">{{ option.title }}</bdi></label>
    <p
      v-if="message"
      role="status"
    >
      {{ message }}
    </p><p
      v-if="searched && !loading && !options.length && !message"
      role="status"
    >
      {{ words.noOptions }}
    </p>
  </div>
</template>
<script>
import axios from '@/libs/axios'
import messages from '../contentCampaign/messages'
import { errorKey } from '../contentCampaign/model'

export default {
  props: {
    value: { type: Array, default: () => [] }, kind: { type: String, required: true }, title: { type: String, required: true }, locale: { type: String, default: 'fa' }, maximum: { type: Number, default: 20 },
  },
  data() {
    return {
      search: '', options: [], selected: [], lookupState: {}, loading: false, message: '', sequence: 0, lookupSequence: 0, searched: false,
    }
  },
  computed: { words() { return messages[this.$i18n.locale] || messages.fa }, endpoint() { return 'articles/doctor-target-options' } },
  watch: { value: { deep: true, handler() { this.selected = this.selected.filter(item => this.value.includes(item.id)); this.hydrate() } }, locale() { this.reset() } },
  created() { this.hydrate() },
  beforeDestroy() { this.sequence += 1; this.lookupSequence += 1 },
  methods: {
    name(id) { const found = this.selected.find(item => item.id === id); if (found) return found.title; if (this.lookupState[id] === 'failed') return this.words.lookupFailed; if (this.lookupState[id] === 'unavailable') return this.words.optionUnavailable; return this.words.loading },
    reset() { this.sequence += 1; this.lookupSequence += 1; this.loading = false; this.options = []; this.selected = []; this.lookupState = {}; this.message = ''; this.searched = false; this.hydrate() },
    rows(response) { if (!response.data || !Array.isArray(response.data.data)) throw new Error('INVALID_OPTIONS'); return response.data.data.map(item => ({ ...item, title: item.name })).filter(item => item && /^[a-f0-9]{24}$/i.test(item.id || '') && typeof item.title === 'string' && item.title.trim()) },
    remove(id) { this.selected = this.selected.filter(item => item.id !== id); this.$emit('input', this.value.filter(item => item !== id)) },
    toggle(option) { if (this.value.includes(option.id)) { if (this.maximum !== 1) this.remove(option.id); return } if (this.maximum === 1) { this.selected = [option]; this.$emit('input', [option.id]) } else if (this.value.length < this.maximum) { this.selected = [...this.selected.filter(item => item.id !== option.id), option]; this.$emit('input', [...this.value, option.id]) } },
    async hydrate() {
      this.lookupSequence += 1; const sequence = this.lookupSequence; const ids = this.value.filter(id => !this.selected.some(item => item.id === id)).slice(0, 20)
      if (!ids.length) return
      ids.forEach(id => this.$set(this.lookupState, id, 'loading')); const batches = []; for (let index = 0; index < ids.length; index += 20) batches.push(ids.slice(index, index + 20))
      try {
        const responses = await Promise.all(batches.map(batch => axios.post(this.endpoint, {
          kind: this.kind, ids: batch,
        }, { timeout: 10000, headers: { lang: this.locale } }))); if (sequence !== this.lookupSequence) return; const options = responses.flatMap(response => this.rows(response)).filter(item => this.value.includes(item.id)); this.selected = [...this.selected.filter(item => this.value.includes(item.id)), ...options]; ids.forEach(id => this.$set(this.lookupState, id, options.some(item => item.id === id) ? 'ready' : 'unavailable'))
      } catch (error) { if (sequence === this.lookupSequence) ids.forEach(id => this.$set(this.lookupState, id, 'failed')) }
    },
    async find() {
      if (this.search.trim().length < 2) return
      this.sequence += 1; const { sequence } = this; this.loading = true; this.message = ''; this.searched = true
      try {
        const response = await axios.post(this.endpoint, {
          kind: this.kind, search: this.search.trim(),
        }, { timeout: 10000, headers: { lang: this.locale } }); if (sequence !== this.sequence) return; this.options = this.rows(response); const recovered = this.options.filter(item => this.value.includes(item.id)); this.selected = [...this.selected.filter(item => !recovered.some(option => option.id === item.id)), ...recovered]
      } catch (error) { if (sequence === this.sequence) this.message = this.words[errorKey(error)] } finally { if (sequence === this.sequence) this.loading = false }
    },
  },
}
</script>

<style scoped>
.doctor-target input[type='radio'] { width: 19px; height: 19px; min-height: 19px; padding: 0; flex-shrink: 0; accent-color: #257d92; }
</style>
